import { ReactNode } from 'react';

import { DataDogGlobal } from '@/analytics';
import { Footer } from '@/app/components';
import { fetchFeaturedPosts } from '@/app/components/NavMenu/actions';
import { AffiliateId, FunnelType } from '@/models';

import { Header } from './Header';

type Props = {
  children: ReactNode;
  colorMode?: 'light' | 'dark';
};

export const HomeSolarLayout = async ({ children, colorMode = 'light' }: Props) => {
  const featuredPosts = await fetchFeaturedPosts();

  return (
    <div id="top">
      <Header colorMode={colorMode} featuredPosts={featuredPosts} />
      {children}
      <Footer fallbackAffiliateId={AffiliateId.AURORA_BLOG} />
      <DataDogGlobal funnel={FunnelType.BLOG} />
    </div>
  );
};
